import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';
import { isFnoPartner } from '@sr/utils';
import { useLocations } from '../Locations';

type NBPOrderIdTooltipProps = {
  selectedLocations: string[];
};

export const useNBPOrderIdTooltip = ({ selectedLocations }: NBPOrderIdTooltipProps) => {
  const { locationsById } = useLocations();
  const { t } = useTranslation();

  const show = useMemo(() => {
    const anyFnoLocation = selectedLocations.some((locationId) => {
      const location = locationsById[locationId];

      if (!location) {
        return false;
      }

      return isFnoPartner(location);
    });

    return anyFnoLocation;
  }, [selectedLocations, locationsById]);

  return {
    show,
    text: t('nbp.orderid.info'),
  };
};
